var downloadFile = '/filemgr/web/file/downLoad';
export default downloadFile;